import { render, staticRenderFns } from "./searchTemplate.vue?vue&type=template&id=40189504&scoped=true"
import script from "./searchTemplate.vue?vue&type=script&lang=js"
export * from "./searchTemplate.vue?vue&type=script&lang=js"
import style0 from "./searchTemplate.vue?vue&type=style&index=0&id=40189504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40189504",
  null
  
)

export default component.exports